import React, { useState } from 'react';
import { Search, TrendingUp, ShoppingCart, DollarSign, X, SlidersHorizontal, Sparkles, Plus, ChevronLeft, ChevronRight, ChevronDown } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { useToast } from '../contexts/ToastContext';
type CategoryType = 'All' | 'RaceLookup Swag' | 'Trophies & Medals' | 'Clothing';
interface Product {
  id: number;
  name: string;
  category: string;
  price: number;
  image: string;
  description: string;
}
export function Store() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategories, setSelectedCategories] = useState<Set<string>>(new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const {
    addToCart
  } = useCart();
  const {
    showToast
  } = useToast();
  const PRODUCTS_PER_PAGE = 9;
  const handleAddToCart = (product: Product) => {
    addToCart(product);
    showToast(`${product.name} added to cart!`, 'success');
  };
  const products: Product[] = [{
    id: 1,
    name: 'RaceLookup Performance Tee',
    category: 'RaceLookup Swag',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Moisture-wicking performance shirt with RaceLookup logo'
  }, {
    id: 2,
    name: 'Marathon Finisher Trophy',
    category: 'Trophies & Medals',
    price: 49.99,
    image: 'https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Premium gold-plated marathon finisher trophy'
  }, {
    id: 3,
    name: 'Running Shorts - Pro',
    category: 'Clothing',
    price: 39.99,
    image: 'https://images.unsplash.com/photo-1591195853828-11db59a44f6b?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Lightweight running shorts with built-in compression'
  }, {
    id: 4,
    name: 'RaceLookup Water Bottle',
    category: 'RaceLookup Swag',
    price: 19.99,
    image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Insulated stainless steel water bottle - 24oz'
  }, {
    id: 5,
    name: 'Custom Race Medal',
    category: 'Trophies & Medals',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Personalized race medal with custom engraving'
  }, {
    id: 6,
    name: 'Performance Running Jacket',
    category: 'Clothing',
    price: 89.99,
    image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Weather-resistant jacket with reflective details'
  }, {
    id: 7,
    name: 'RaceLookup Cap',
    category: 'RaceLookup Swag',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Breathable running cap with adjustable strap'
  }, {
    id: 8,
    name: 'Victory Medal Set',
    category: 'Trophies & Medals',
    price: 34.99,
    image: 'https://images.unsplash.com/photo-1611085583191-a3b181a88401?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Set of 3 medals - Gold, Silver, Bronze'
  }, {
    id: 9,
    name: 'Compression Socks',
    category: 'Clothing',
    price: 16.99,
    image: 'https://images.unsplash.com/photo-1586350977771-b3b0abd50c82?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Graduated compression for improved circulation'
  }, {
    id: 10,
    name: 'Running Gloves',
    category: 'Clothing',
    price: 22.99,
    image: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Touchscreen-compatible thermal running gloves'
  }, {
    id: 11,
    name: 'RaceLookup Backpack',
    category: 'RaceLookup Swag',
    price: 54.99,
    image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Durable backpack with hydration bladder pocket'
  }, {
    id: 12,
    name: 'Finisher Medal Display',
    category: 'Trophies & Medals',
    price: 39.99,
    image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Wall-mounted display rack for race medals'
  }, {
    id: 13,
    name: 'Running Belt',
    category: 'Clothing',
    price: 18.99,
    image: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Adjustable belt with multiple pockets for essentials'
  }, {
    id: 14,
    name: 'RaceLookup Hoodie',
    category: 'RaceLookup Swag',
    price: 44.99,
    image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Comfortable cotton-blend hoodie with logo'
  }, {
    id: 15,
    name: 'Race Bib Holder',
    category: 'Trophies & Medals',
    price: 14.99,
    image: 'https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=800&h=800&fit=crop&auto=format&q=80',
    description: 'Magnetic race bib holder - no pins needed'
  }];
  const categories = ['RaceLookup Swag', 'Trophies & Medals', 'Clothing'];
  const toggleCategory = (category: string) => {
    const newCategories = new Set(selectedCategories);
    if (newCategories.has(category)) {
      newCategories.delete(category);
    } else {
      newCategories.add(category);
    }
    setSelectedCategories(newCategories);
    setCurrentPage(1);
  };
  const activeFiltersCount = selectedCategories.size;
  const filteredProducts = products.filter(product => {
    const matchesSearch = searchQuery === '' || product.name.toLowerCase().includes(searchQuery.toLowerCase()) || product.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategories.size === 0 || selectedCategories.has(product.category);
    return matchesSearch && matchesCategory;
  });
  const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);
  const startIndex = (currentPage - 1) * PRODUCTS_PER_PAGE;
  const endIndex = startIndex + PRODUCTS_PER_PAGE;
  const currentProducts = filteredProducts.slice(startIndex, endIndex);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 400,
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-gray-50 min-h-screen pb-20" data-id="element-2182">
      {/* Banner */}
      <div className="relative h-[300px] sm:h-[400px] overflow-hidden" data-id="element-2183">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1920&h=400&fit=crop&auto=format&q=80)'
      }} data-id="element-2184">
          <div className="absolute inset-0 bg-gradient-to-r from-[#0E578E]/95 via-[#0E578E]/90 to-[#01AAE7]/85" data-id="element-2185"></div>
        </div>

        <div className="absolute inset-0" data-id="element-2186">
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }} data-id="element-2187"></div>
        </div>

        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-center" data-id="element-2188">
          <div className="text-center max-w-3xl" data-id="element-2189">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-6 border border-white/30 shadow-lg" data-id="element-2190">
              <TrendingUp className="h-3.5 sm:h-4 w-3.5 sm:w-4" data-id="element-2191" />
              {products.length} Products Available
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-3 sm:mb-4 leading-tight drop-shadow-lg px-4" data-id="element-2192">
              RaceLookup Store
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-white/95 leading-relaxed max-w-2xl mx-auto drop-shadow-md px-4" data-id="element-2193">
              Premium running gear, trophies, and official RaceLookup
              merchandise
            </p>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0" data-id="element-2194">
          <svg viewBox="0 0 1440 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-2195">
            <path d="M0 48H1440V24C1440 24 1200 0 720 0C240 0 0 24 0 24V48Z" fill="#F9FAFB" data-id="element-2196" />
          </svg>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 mt-6 sm:mt-8" data-id="element-2197">
        {/* Mobile: Filter Icon Button */}
        <div className="lg:hidden mb-6" data-id="element-2198">
          <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="relative w-full flex items-center justify-between gap-3 px-5 py-4 bg-white rounded-xl shadow-lg border-2 border-gray-200 hover:border-[#01AAE7] transition-all" data-id="element-2199">
            <div className="flex items-center gap-3" data-id="element-2200">
              <div className="w-10 h-10 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] rounded-lg flex items-center justify-center" data-id="element-2201">
                <SlidersHorizontal className="h-5 w-5 text-white" data-id="element-2202" />
              </div>
              <div className="text-left" data-id="element-2203">
                <div className="text-sm font-bold text-gray-900" data-id="element-2204">
                  Filters & Search
                </div>
                <div className="text-xs text-gray-500" data-id="element-2205">
                  {activeFiltersCount > 0 ? `${activeFiltersCount} active` : 'Tap to filter'}
                </div>
              </div>
            </div>
            <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${showMobileFilters ? 'rotate-180' : ''}`} data-id="element-2206" />
            {activeFiltersCount > 0 && <span className="absolute -top-2 -right-2 bg-[#01AAE7] text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center shadow-lg" data-id="element-2207">
                {activeFiltersCount}
              </span>}
          </button>

          {/* Mobile Filter Dropdown */}
          {showMobileFilters && <div className="mt-4 bg-white rounded-xl shadow-xl border border-gray-200 p-5 space-y-4" data-id="element-2208">
              {/* Search Bar */}
              <div className="relative" data-id="element-2209">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 z-10" data-id="element-2210" />
                <input type="text" placeholder="Search products..." value={searchQuery} onChange={e => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }} className="w-full pl-12 pr-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-900 transition-all" data-id="element-2211" />
                {searchQuery && <button onClick={() => {
              setSearchQuery('');
              setCurrentPage(1);
            }} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-2212">
                    <X className="h-4 w-4" data-id="element-2213" />
                  </button>}
              </div>

              {/* Categories */}
              <div data-id="element-2214">
                <label className="flex items-center gap-2 text-sm font-bold text-gray-700 mb-3" data-id="element-2215">
                  <Sparkles className="h-4 w-4 text-[#01AAE7]" data-id="element-2216" />
                  Categories
                </label>
                <div className="space-y-2" data-id="element-2217">
                  {categories.map(category => <label key={category} className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-all ${selectedCategories.has(category) ? 'bg-gradient-to-r from-[#01AAE7]/10 to-[#0E578E]/10 border-2 border-[#01AAE7]' : 'bg-gray-50 border-2 border-gray-200 hover:border-[#01AAE7]/50'}`} data-id="element-2218">
                      <input type="checkbox" checked={selectedCategories.has(category)} onChange={() => toggleCategory(category)} className="w-5 h-5 rounded-lg border-2 border-gray-300 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] cursor-pointer" data-id="element-2219" />
                      <span className={`text-sm font-semibold ${selectedCategories.has(category) ? 'text-[#0E578E]' : 'text-gray-700'}`} data-id="element-2220">
                        {category}
                      </span>
                    </label>)}
                </div>
              </div>

              {/* Clear All & Apply Buttons */}
              <div className="flex gap-3 pt-3 border-t border-gray-200" data-id="element-2221">
                {activeFiltersCount > 0 && <button onClick={() => {
              setSearchQuery('');
              setSelectedCategories(new Set());
              setCurrentPage(1);
            }} className="flex-1 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-xl transition-all" data-id="element-2222">
                    Clear All
                  </button>}
                <button onClick={() => setShowMobileFilters(false)} className="flex-1 px-4 py-3 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg" data-id="element-2223">
                  Apply Filters
                </button>
              </div>
            </div>}
        </div>

        <div className="flex flex-col lg:flex-row gap-6 sm:gap-8" data-id="element-2224">
          {/* Desktop Filter Sidebar - Hidden on mobile */}
          <div className="hidden lg:block w-full lg:w-[30%]" data-id="element-2225">
            <div className="lg:sticky lg:top-8" data-id="element-2226">
              <div className="bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-2xl border border-gray-200 overflow-hidden" data-id="element-2227">
                <div className="bg-gradient-to-r from-[#0E578E] to-[#01AAE7] p-6" data-id="element-2228">
                  <div className="flex items-center justify-between" data-id="element-2229">
                    <div className="flex items-center gap-3" data-id="element-2230">
                      <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-2231">
                        <SlidersHorizontal className="h-5 w-5 text-white" data-id="element-2232" />
                      </div>
                      <h3 className="text-xl font-black text-white" data-id="element-2233">
                        Refine Search
                      </h3>
                    </div>
                    {activeFiltersCount > 0 && <div className="bg-white/20 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full border border-white/30" data-id="element-2234">
                        {activeFiltersCount} active
                      </div>}
                  </div>
                </div>

                <div className="p-6 space-y-6" data-id="element-2235">
                  <div data-id="element-2236">
                    <label className="flex items-center gap-2 text-sm font-bold text-gray-700 mb-3" data-id="element-2237">
                      <Search className="h-4 w-4 text-[#01AAE7]" data-id="element-2238" />
                      Search Products
                    </label>
                    <div className="relative group" data-id="element-2239">
                      <input type="text" placeholder="Find your perfect gear..." value={searchQuery} onChange={e => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }} className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:ring-4 focus:ring-[#01AAE7]/10 text-gray-900 text-sm transition-all placeholder:text-gray-400" data-id="element-2240" />
                      {searchQuery && <button onClick={() => {
                      setSearchQuery('');
                      setCurrentPage(1);
                    }} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-2241">
                          <X className="h-4 w-4" data-id="element-2242" />
                        </button>}
                    </div>
                  </div>

                  <div className="relative" data-id="element-2243">
                    <div className="absolute inset-0 flex items-center" data-id="element-2244">
                      <div className="w-full border-t border-gray-200" data-id="element-2245"></div>
                    </div>
                    <div className="relative flex justify-center" data-id="element-2246">
                      <span className="bg-gradient-to-br from-white to-gray-50 px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2247">
                        Filters
                      </span>
                    </div>
                  </div>

                  <div data-id="element-2248">
                    <label className="flex items-center gap-2 text-sm font-bold text-gray-700 mb-4" data-id="element-2249">
                      <Sparkles className="h-4 w-4 text-[#01AAE7]" data-id="element-2250" />
                      Categories
                    </label>
                    <div className="space-y-2" data-id="element-2251">
                      {categories.map(category => <label key={category} className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-all group ${selectedCategories.has(category) ? 'bg-gradient-to-r from-[#01AAE7]/10 to-[#0E578E]/10 border-2 border-[#01AAE7]' : 'bg-white border-2 border-gray-200 hover:border-[#01AAE7]/50 hover:bg-gray-50'}`} data-id="element-2252">
                          <input type="checkbox" checked={selectedCategories.has(category)} onChange={() => toggleCategory(category)} className="w-5 h-5 rounded-lg border-2 border-gray-300 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer transition-all" data-id="element-2253" />
                          <span className={`text-sm font-semibold transition-colors ${selectedCategories.has(category) ? 'text-[#0E578E]' : 'text-gray-700 group-hover:text-[#0E578E]'}`} data-id="element-2254">
                            {category}
                          </span>
                        </label>)}
                    </div>
                  </div>

                  {activeFiltersCount > 0 && <button onClick={() => {
                  setSearchQuery('');
                  setSelectedCategories(new Set());
                  setCurrentPage(1);
                }} className="w-full px-4 py-3 bg-gradient-to-r from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 text-gray-700 text-sm font-bold rounded-xl transition-all shadow-sm hover:shadow-md flex items-center justify-center gap-2 group" data-id="element-2255">
                      <X className="h-4 w-4 group-hover:rotate-90 transition-transform duration-300" data-id="element-2256" />
                      Clear All Filters
                    </button>}
                </div>
              </div>
            </div>
          </div>

          {/* Products Grid */}
          <div className="w-full lg:w-[70%]" data-id="element-2257">
            <div className="mb-4 sm:mb-6" data-id="element-2258">
              <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-500 font-medium" data-id="element-2259">
                <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-2260"></div>
                <span data-id="element-2261">
                  Showing {startIndex + 1}-
                  {Math.min(endIndex, filteredProducts.length)} of{' '}
                  {filteredProducts.length} product
                  {filteredProducts.length !== 1 ? 's' : ''}
                  {selectedCategories.size > 0 && ` in ${Array.from(selectedCategories).join(', ')}`}
                </span>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-2262">
              {currentProducts.length > 0 ? currentProducts.map(product => <div key={product.id} className="group bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100" data-id="element-2263">
                    <div className="relative h-48 sm:h-56 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200" data-id="element-2264">
                      <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-2265" />

                      <div className="absolute top-3 sm:top-4 left-3 sm:left-4" data-id="element-2266">
                        <span className="inline-block bg-white/95 backdrop-blur-sm text-[#0E578E] text-xs font-bold px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full shadow-lg border border-gray-200" data-id="element-2267">
                          {product.category}
                        </span>
                      </div>
                    </div>

                    <div className="p-4 sm:p-5" data-id="element-2268">
                      <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 line-clamp-1 group-hover:text-[#0E578E] transition-colors" data-id="element-2269">
                        {product.name}
                      </h3>
                      <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4 line-clamp-2 leading-relaxed" data-id="element-2270">
                        {product.description}
                      </p>

                      <div className="flex items-center justify-between pt-3 sm:pt-4 border-t border-gray-100" data-id="element-2271">
                        <div data-id="element-2272">
                          <div className="text-xs text-gray-500 font-medium mb-0.5" data-id="element-2273">
                            Price
                          </div>
                          <div className="text-xl sm:text-2xl font-black text-[#0E578E]" data-id="element-2274">
                            ${product.price.toFixed(2)}
                          </div>
                        </div>
                        <button onClick={() => handleAddToCart(product)} className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] text-white rounded-lg sm:rounded-xl hover:from-[#01AAE7] hover:to-[#0E578E] transition-all shadow-lg hover:shadow-xl flex items-center justify-center group/btn" data-id="element-2275">
                          <ShoppingCart className="h-4 sm:h-5 w-4 sm:w-5 group-hover/btn:scale-110 transition-transform" data-id="element-2276" />
                        </button>
                      </div>
                    </div>
                  </div>) : <div className="col-span-full text-center py-12 sm:py-16" data-id="element-2277">
                  <div className="text-gray-400 mb-4" data-id="element-2278">
                    <Search className="h-12 sm:h-16 w-12 sm:w-16 mx-auto mb-4" data-id="element-2279" />
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2" data-id="element-2280">
                    No products found
                  </h3>
                  <p className="text-sm sm:text-base text-gray-500 mb-4" data-id="element-2281">
                    Try adjusting your filters or search query
                  </p>
                  <button onClick={() => {
                setSearchQuery('');
                setSelectedCategories(new Set());
                setCurrentPage(1);
              }} className="px-5 sm:px-6 py-2 bg-[#01AAE7] text-white font-semibold rounded-lg hover:bg-[#0199d6] transition-colors text-sm sm:text-base" data-id="element-2282">
                    Clear All Filters
                  </button>
                </div>}
            </div>

            {filteredProducts.length > 0 && totalPages > 1 && <div className="mt-8 sm:mt-10 flex justify-center lg:justify-end" data-id="element-2283">
                <div className="inline-flex items-center gap-1 sm:gap-2 bg-white rounded-xl shadow-lg border border-gray-200 p-1.5 sm:p-2" data-id="element-2284">
                  <button onClick={() => handlePageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1} className="w-8 sm:w-10 h-8 sm:h-10 flex items-center justify-center rounded-lg text-gray-600 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-all" data-id="element-2285">
                    <ChevronLeft className="h-4 sm:h-5 w-4 sm:w-5" data-id="element-2286" />
                  </button>

                  <div className="flex items-center gap-0.5 sm:gap-1 px-1" data-id="element-2287">
                    {Array.from({
                  length: Math.min(totalPages, 5)
                }, (_, i) => i + 1).map(page => <button key={page} onClick={() => handlePageChange(page)} className={`min-w-[32px] sm:min-w-[40px] h-8 sm:h-10 px-2 sm:px-3 flex items-center justify-center rounded-lg text-xs sm:text-sm font-bold transition-all ${currentPage === page ? 'bg-gradient-to-br from-[#0E578E] to-[#01AAE7] text-white shadow-md' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-2288">
                        {page}
                      </button>)}
                    {totalPages > 5 && <>
                        <span className="px-1 sm:px-2 text-gray-400 text-xs sm:text-sm font-bold" data-id="element-2289">
                          •••
                        </span>
                        <button onClick={() => handlePageChange(totalPages)} className={`min-w-[32px] sm:min-w-[40px] h-8 sm:h-10 px-2 sm:px-3 flex items-center justify-center rounded-lg text-xs sm:text-sm font-bold transition-all ${currentPage === totalPages ? 'bg-gradient-to-br from-[#0E578E] to-[#01AAE7] text-white shadow-md' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-2290">
                          {totalPages}
                        </button>
                      </>}
                  </div>

                  <button onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} className="w-8 sm:w-10 h-8 sm:h-10 flex items-center justify-center rounded-lg text-gray-600 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-all" data-id="element-2291">
                    <ChevronRight className="h-4 sm:h-5 w-4 sm:w-5" data-id="element-2292" />
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}